module.exports = __webpack_public_path__ + "static/media/icn_random_active.cffb9599.svg";